import React from "react";
import './coordinates.scss';
import CWConfirm from "../common/cw-confirmation-modal/cw-confirmation-modal";

class Coordinates extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            minsPlayed: 0,
            secsPlayed: 0,
            answeredQuestion: false,
            fullScreenMode: false
        };
        this.videoRef = React.createRef();
    }

    componentDidMount() {
        // document.addEventListener("fullscreenchange", function () {
        //     console.log("docurmnet", document.fullscreenElement);
        //     if (document.fullscreenElement != null) {
        //         console.log("Went full screen");

        //     } else {
        //         console.log("Exited full screen");
        //     }
        // }, false);
        // //    document.addEventListener("mozfullscreenchange", function () {
        // //         console.log("moz", document.mozFullScreen);
        // //    }, false);
        // //    document.addEventListener("webkitfullscreenchange", function () {
        // //         console.log('webkit', document.webkitIsFullScreen);
        // //    }, false);
    }


    updateTimePlayed = () => {
        console.log(this.videoRef)
        if (this.videoRef.current) {
            const currentTime = Math.floor(this.videoRef.current.currentTime);
            const minutes = Math.floor(currentTime / 60);
            const seconds = currentTime % 60;
            console.log(minutes, seconds)
            if (seconds === 4 && !this.state.answeredQuestion) {
                if (document.fullscreenElement) {
                    document.exitFullscreen()
                }
                this.pauseVideo()
            }

            this.setState({ minsPlayed: minutes, secsPlayed: seconds });
        }
    };


    pauseVideo = () => {
        if (this.videoRef.current) {
            this.videoRef.current.pause();
            this.setState({ showConfirmModal: true })
        }
    };

    playVideo = () => {
        if (this.videoRef.current) {
            this.videoRef.current.play();
            this.setState({ answeredQuestion: true })
        }
    };

    hideConfirmModal = () => {
        this.setState({ showConfirmModal: false }, () => {
            this.playVideo()
        })
    }


    render() {

        return (
            <div>
                {/* <iframe scrolling="no" 
                title="Meaning of Coordinates" 
                src="https://www.geogebra.org/material/iframe/id/h9kjwhbp/width/800/height/500/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/false/sdz/false/ctl/false" 
                width="800px"
                 height="500px" 
                 style={{border : '0px'}}
                 > </iframe> */}
                {
                    <div>
                        <video
                            ref={this.videoRef}
                            src='https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/a98ffabc-2ad2-4e1e-9caa-d51426d5d6d0_Mean%20Median%20Mode%20Range%20Rap%20Song%20with%20Worksheets.mp4'
                            controlslist="nodownload noremoteplayback noplaybackrate foobar"
                            controls
                            // controlsList="nodownload"

                            onTimeUpdate={this.updateTimePlayed}
                        ></video>
                        {
                            this.state.showConfirmModal && <CWConfirm
                                modal={this.state.showConfirmModal}
                                close={this.hideConfirmModal}
                                message={"Answer the Question to Continue Watching the Video"}
                                onOk={this.hideConfirmModal}
                            />
                        }
                    </div>
                }
            </div>
        )
    }

}

export default Coordinates;